// Utility helpers to centralize storing and retrieving authenticated user info
export function setUserData(obj) {
  try {
    localStorage.setItem("userData", JSON.stringify(obj || {}));
    const mobile =
      obj?.data?.mobile_no || obj?.data?.mobile || obj?.mobile_no || obj?.mobile || "";
    if (mobile) localStorage.setItem("userMobile", mobile);
  } catch (e) {
    console.error("setUserData failed", e);
  }
}

export function getUserData() {
  try {
    const raw = localStorage.getItem("userData");
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.error("getUserData failed", e);
    return null;
  }
}

export function getUserMobile() {
  try {
    const rawMobile = localStorage.getItem("userMobile");
    if (rawMobile) return rawMobile;
    const obj = getUserData();
    return (
      obj?.data?.mobile_no || obj?.data?.mobile || obj?.mobile_no || obj?.mobile || ""
    );
  } catch (e) {
    console.error("getUserMobile failed", e);
    return "";
  }
}

export function clearUserData() {
  try {
    localStorage.removeItem("userData");
    localStorage.removeItem("userMobile");
  } catch (e) {
    console.error("clearUserData failed", e);
  }
}

// Merge a partial profile into existing stored userData.data and persist
export function mergeAndSetUserData(partial = {}) {
  try {
    const existing = getUserData() || {};
    const merged = {
      ...existing,
      data: {
        ...(existing.data || {}),
        ...(partial || {}),
      },
    };
    setUserData(merged);
    return merged;
  } catch (e) {
    console.error("mergeAndSetUserData failed", e);
    return null;
  }
}
